import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCoachOnboardingProcessThunk } from "../redux/Slices/onboardingSlice";
import { useParams } from "react-router-dom";
import { Button } from "react-bootstrap";

const StripeCoachOnboard = () => {
  const dispatch = useDispatch();
  const {
    coachOnboardingProcess,
    loadingOnboardingProcess,
    onboardingProcessError,
  } = useSelector((state) => state.onboarding);

  const { offerID } = useParams();

  useEffect(() => {
    if (coachOnboardingProcess?.url) {
      window.location.href = coachOnboardingProcess?.url;
    }
  }, [coachOnboardingProcess]);
  const handleSetupPayout = async () => {
    if (offerID) {
      dispatch(fetchCoachOnboardingProcessThunk({ offerID }));
    }
  };

  return (
    <div className=" formContainer d-flex justify-content-center align-items-center bg-light min-vh-100">
      <div className="w-100 p-4 p-md-5" style={{ maxWidth: "500px" }}>
        <div className="bg-white rounded-lg shadow-md p-4 p-md-5">
          <div className="text-center mb-4">
            <h2 className="text-2xl font-bold text-gray-800 mb-3">
              Welcome! <br /> Let's Set Up Your Payout Account with RoarAI
            </h2>
            <p className="text-gray-600 mb-4">
              To receive your coaching earnings, we'll need to set you up with
              Stripe, our secure payout provider.
            </p>
          </div>

          {onboardingProcessError ? (
            <div className="alert alert-danger mb-2">
              {onboardingProcessError}
            </div>
          ) : (
            <Button
              onClick={handleSetupPayout}
              disabled={loadingOnboardingProcess}
              className={`btn w-100 saveButton`}
            >
              {loadingOnboardingProcess
                ? "Redirecting..."
                : "Set Up Your Payout Account"}
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default StripeCoachOnboard;
